import hash from 'object-hash';

/**
 * A utility class for generating short hash strings.
 * Uses object-hash library for consistent and well-distributed hashing.
 * Do NOT use this for security/cryptographic purposes - use EncryptionUtil instead.
 */
export class HashUtil {
  private static _instance: HashUtil;

  static get instance(): HashUtil {
    if (!HashUtil._instance) {
      HashUtil._instance = new HashUtil();
    }
    return HashUtil._instance;
  }

  private constructor() {
    // Private constructor to enforce singleton pattern
  }

  /**
   * Hashes a string into a short string representation.
   * The output is an 8-character string.
   *
   * @param input - The string to hash
   * @returns A short hash string
   */
  hash<T>(input: T): string {
    const fullHash = hash(JSON.stringify(input));
    return fullHash;
  }
}

/**
 * Gets the singleton instance of HashUtil.
 */
export const getHashUtil = (): HashUtil => HashUtil.instance;
